// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"TaxStatusLabel-module__flexRow--2wp_q","tooltip":"TaxStatusLabel-module__tooltip--2sWLe"};